import { render, staticRenderFns } from "./VineyardProfileComponent.vue?vue&type=template&id=c62ed490&scoped=true&"
import script from "./VineyardProfileComponent.vue?vue&type=script&lang=js&"
export * from "./VineyardProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./VineyardProfileComponent.vue?vue&type=style&index=0&id=c62ed490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62ed490",
  null
  
)

export default component.exports